import { Component } from '@verndale/core';
import { calculateLeftBorderHeight, updateHomepageDynamicStyles } from '../utils';
import { customEvents, RUN_ANIMATION_KEY } from '../helpers/constants';


class HomepageMasthead extends Component {
  setupDefaults() {
    this.wasWelcomeAnimationExecuted = window.localStorage.getItem(RUN_ANIMATION_KEY);
    this.dom = {
      mediaContainer: this.el.querySelector('.homepage-masthead__media-container'),
      vimeoVideo: this.el.querySelector('.homepage-masthead__media-container .vimeo-video'),
      homepageAnimation: document.querySelector('.homepage-animation'),
      leftBorder: document.querySelector('.homepage-masthead__left-border'),
      homepageMastheadHeader: document.querySelector('.homepage-masthead__header'),
      headerExpandedShortcuts: document.querySelector(
        '.header__expanded-shortcuts'
      )
    };
    this.addVideoClass();
    this.dom.homepageMastheadHeader.style.minHeight = `${this.dom.headerExpandedShortcuts.offsetHeight}px`
    this.watchMainElement();
  }

  watchMainElement() {
    const resizeObserver = new ResizeObserver(entries => {
      if (!this.dom.homepageAnimation || this.wasWelcomeAnimationExecuted) updateHomepageDynamicStyles();
      calculateLeftBorderHeight(this.dom.leftBorder);
    });

    resizeObserver.observe(document.querySelector('body, main'));
  }

  addListeners() {
    window.addEventListener(customEvents.leftBorderResizeTrigger, () => {
      calculateLeftBorderHeight(this.dom.leftBorder);
    });
  }

  addVideoClass() {
    if (this.dom.vimeoVideo) {
      this.dom.mediaContainer.classList.add('with-video')
    }
  }
}

export default HomepageMasthead;
